import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=4a0f48ac&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=4a0f48ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0f48ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0f48ac')) {
      api.createRecord('4a0f48ac', component.options)
    } else {
      api.reload('4a0f48ac', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=4a0f48ac&scoped=true&", function () {
      api.rerender('4a0f48ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xkQrndBlEdtZ/JS/comp/DateRangeExt.vue"
export default component.exports